export { default as Img200 } from './processed/200/City-of-Angels.jpg';
export { default as Img400 } from './processed/400/City-of-Angels.jpg';
export { default as Imgthumb } from './processed/thumb/City-of-Angels.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/City-of-Angels.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/City-of-Angels.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      202,
      116,
      78
    ],
    "_population": 3816,
    "_hsl": [
      0.051075268817204304,
      0.5391304347826086,
      0.5490196078431373
    ]
  },
  "LightVibrant": {
    "_rgb": [
      229,
      170,
      116
    ],
    "_population": 2613,
    "_hsl": [
      0.07964601769911503,
      0.6848484848484847,
      0.6764705882352942
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      93,
      49,
      40
    ],
    "_population": 1262,
    "_hsl": [
      0.02830188679245284,
      0.3984962406015038,
      0.26078431372549016
    ]
  },
  "Muted": {
    "_rgb": [
      157,
      100,
      73
    ],
    "_population": 805,
    "_hsl": [
      0.05357142857142857,
      0.3652173913043479,
      0.45098039215686275
    ]
  },
  "LightMuted": {
    "_rgb": [
      180,
      178,
      177
    ],
    "_population": 33,
    "_hsl": [
      0.05555555555555503,
      0.019607843137255023,
      0.7
    ]
  },
  "DarkMuted": {
    "_rgb": [
      64,
      43,
      37
    ],
    "_population": 1970,
    "_hsl": [
      0.03703703703703704,
      0.2673267326732673,
      0.19803921568627453
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/City-of-Angels.js